import onLoad from "./stop/stop-loader";
// This is technically the onLoad() function
onLoad();
